export const USE_RETRIEVE_TEAM_FEED = "useRetrieveTeamFeed";
export const USE_RETRIEVE_PLAYER_FEED = "useRetrievePlayerFeed";
